{
  "header": "Welcome to the Bigleaf Cloud Connect",
  "invalid_credentials": "The user name or password you entered didn't match our records. Try again.",
  "login": "Log in",
  "password": {
    "label": "Password",
    "placeholder": "Enter your password",
    "required": "Password is required"
  },
  "unauthorized": "Unauthorized. Log in to continue.",
  "unknown_error": "There was an unknown error. Try again",
  "username": {
    "label": "User name",
    "placeholder": "Enter your user name",
    "required": "User name is required"
  }
}
